import { useV2CreateReleaseFlagMutation } from "@generated";
import { ReleaseFlagFormValues } from "../../types";

const useCreateReleaseFlag = () => {
  const [createReleaseFlag, state] = useV2CreateReleaseFlagMutation();

  const submit = (values: ReleaseFlagFormValues) =>
    createReleaseFlag({
      body: {
        data: {
          type: "release-flags",
          attributes: {
            name: values.name,
            key: values.key,
            description: values.description,
            status: values.status,
            "beta-release-date": values.betaReleaseDate,
            "general-availability-date": values.generalAvailabilityDate,
          },
        },
      },
    }).unwrap();

  return { submit, isLoading: state.isLoading };
};

export default useCreateReleaseFlag;
